// Shared email-format check. Pragmatic regex — accepts the vast majority of
// real-world addresses while rejecting obvious garbage like "abc", "a@b",
// "foo bar@x.com". Not RFC 5322-perfect on purpose; the backend's
// jakarta.validation @Email is the authoritative check.
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const isValidEmail = (value) =>
    typeof value === "string" && EMAIL_RE.test(value.trim());

// Trim + lowercase for consistent storage. Use before submitting to the
// backend so "  Foo@Bar.COM " becomes "foo@bar.com". Returns the input
// unchanged if it isn't a string (e.g. undefined while form is being filled).
export const normalizeEmail = (value) =>
    typeof value === "string" ? value.trim().toLowerCase() : value;

// MUI TextField props for an email input. Renders inline error styling
// + helperText as the user types. When empty, the helper falls back to
// "*Required" for a required field, or no helper text for an optional one
// (pass { required: false }). A non-empty malformed value always shows the
// format error. Spread onto a TextField: {...emailFieldProps(data?.email)}.
export const emailFieldProps = (value, { required = true } = {}) => {
    const invalid = !!value && !isValidEmail(value);
    return {
        error: invalid,
        helperText: invalid ? "Please enter a valid email" : (required ? "*Required" : ""),
    };
};
